import { render, staticRenderFns } from "./_project.vue?vue&type=template&id=f928d83a&"
import script from "./_project.vue?vue&type=script&lang=js&"
export * from "./_project.vue?vue&type=script&lang=js&"
import style0 from "./_project.vue?vue&type=style&index=0&id=f928d83a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports